import { useNavigate } from "react-router-dom";
import { arrowLeftThin } from "../../images";

const BackButton = () => {
  const navigate = useNavigate();
  return (
    <div className="py-6 hidden lg:block">
      <button
        onClick={() => navigate(-1)}
        className="border-[0.5px] border-[#626262] flex gap-2 items-center py-2 px-6 rounded-[4px]"
      >
        <span>
          <img src={arrowLeftThin} alt="" />
        </span>{" "}
        <span> Back</span>
      </button>
    </div>
  );
};

export default BackButton;
